module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/16_9.7120d32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/16_9.jpg
// module id = 0Y+f
// module chunks = 0